import { tracked } from '@glimmer/tracking';

import type { DateRangeInterface } from 'webapp-types';

import type MetricLimitationGranulation from 'webapp/models-custom/metric-limitation/granulation';

export default class Granulation {
	// to be compatible with date-range objects that have joined properties from multiple limitations

	@tracked id: string;
	@tracked title: string;
	@tracked unit: number;
	@tracked formula: DateRangeInterface.GranulationInterface;

	@tracked limitation: MetricLimitationGranulation | null = null;

	constructor(options: {
		id: string;
		title: string;
		unit: number;
		formula: DateRangeInterface.GranulationInterface;
	}) {
		this.id = options.id;
		this.title = options.title;
		this.unit = options.unit;
		this.formula = options.formula;
	}

	get isDisabled(): boolean {
		return !!this.limitation?.disabled;
	}

	get isDisabledForPaymentReasons(): boolean {
		return !!this.limitation?.isPaidLimitation;
	}

	get infoText(): string {
		return this.limitation?.infoText || '';
	}
}
